<section class="login-container h-100">
  <div class="row justify-content-center align-items-center h-100">
    <div class="card shadow-sm rounded login forgot">
      <h2 class="mb-4 pb-2 card-title">Sign in with Twitter</h2>
      
    </div>
  </div>
</section>